import { SET_INITIAL_AD_BANNERS, AD_BANNERS_LOADED} from '../actions/actionTypes';
import initialState from './initialState';

export default function adBanners(state = initialState.adBanners, action) {
    switch (action.type) {
        case SET_INITIAL_AD_BANNERS:
            return {collection: [], isLoaded: false};
        case AD_BANNERS_LOADED:
            let addedBanners = Object.assign([], state.collection);
            action.banners.map((item, i) => {
                if (!state.collection.find((banner) => banner.id === item.id)) {
                    addedBanners.push(item);
                }
            });
            return {collection: addedBanners, isLoaded: true};
        default:
            return state;
    }
}